const RESTORABLE_TURN_STATUSES = new Set([
  "Alterações aplicadas.",
  "Concluído com pendências.",
  "Pedido não executado.",
  "Interrompido antes da próxima ação.",
  "Execução interrompida.",
  "Solicitação cancelada.",
]);

export function restorableTurnStatus(status: string | undefined): string | undefined {
  return status && RESTORABLE_TURN_STATUSES.has(status) ? status : undefined;
}
